import type { CriminalSubmittedDocumentView } from '../../services/criminalCaseRequests';
import { formatDocumentTableDateTime } from '../../utils/dateFormat';
import { displayClientFileName } from '../../utils/fileDisplayName';

export { formatFileSizeLabel } from '../../utils/fileSize';

export function formatDocUploadedAt(iso?: string): string {
  return formatDocumentTableDateTime(iso) || '—';
}

export function submittedDocUiStatus(doc: CriminalSubmittedDocumentView): 'uploaded' | 'pending' | 'not-uploaded' {
  const s = doc.status.toLowerCase();
  if (s.includes('uploaded') && !s.includes('not')) return 'uploaded';
  if (doc.fileName.trim()) return 'uploaded';
  if (doc.reason.trim()) return 'pending';
  if (s.includes('pending') || s.includes('not_uploaded') || s.includes('not uploaded') || s.includes('not')) {
    return 'pending';
  }
  return 'not-uploaded';
}

/** User-facing file label from documents API (`file_name` / `original_file_name`). */
export function displayDocumentFileName(doc: {
  originalFileName: string | null;
  fileName?: string;
}): string {
  return displayClientFileName(doc.originalFileName, doc.fileName);
}

export type { SubmittedDocumentDisplayRow } from '../task-case/viewDocumentHelpers';
export {
  buildSubmittedDocumentDisplayRows,
  hasDownloadableDocumentFile,
} from '../task-case/viewDocumentHelpers';
